/* eslint-disable @typescript-eslint/no-unused-vars */
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { useRef } from 'react';

import pin from 'assets/images/pin_map.png';
import pinEditMap from 'assets/images/pin_edit_map.png';

import { FieldMarkerProps } from './FieldMarker.type';

export const FieldMarker = ({
    position,
    isSelected = false,
    index,
    onMarkerClick,
    onMarkerDragEnd,
}: FieldMarkerProps) => {
    const markerRef = useRef<L.Marker>(null);

    const eventHandlers = {
        click: () => {
            onMarkerClick(index);
        },
        dragend: () => {
            const marker = markerRef.current;
            if (marker && onMarkerDragEnd) {
                const latlng = marker.getLatLng();
                onMarkerDragEnd([latlng.lat, latlng.lng], index);
            }
        },
    };

    const iconEdit = L.icon({
        iconUrl: pinEditMap,
        iconSize: [69, 80],
        iconAnchor: [8, 1],
        shadowUrl: undefined,
    });

    const iconMap = L.icon({
        iconUrl: pin,
        iconSize: [45, 45],
        iconAnchor: [22.5, 22.5],
        shadowUrl: undefined,
    });

    return (
        <Marker
            ref={markerRef}
            position={position}
            draggable={isSelected}
            eventHandlers={eventHandlers}
            icon={isSelected ? iconEdit : iconMap}
        />
    );
};
